export default __webpack_public_path__ + "static/media/lorenzProjection1b.739be200.svg";